import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
    
  const token = localStorage.getItem("accesstoken");
  return token ? <Navigate to="/dashboard" replace /> : <Outlet />;
};

export default ProtectedRoute;
